module.exports = __webpack_public_path__ + "img/color-balance_jp.ef73f5f.jpg";